import { ProductSchema } from 'api/dbs/models';
import { createProductCardErrorText } from '../createProductCardErrorText';
import { CsProductCardsProduct, ProductDictionary } from 'components/ProductCards/types';
import { ZodError } from 'zod';

const createProductValidator = (dbs: ProductDictionary) => (product: CsProductCardsProduct) => {
  const dbsProduct = dbs[product.product_id];
  if (!dbsProduct) {
    return {
      ...product,
      error: createProductCardErrorText(
        `product ${product.product_id} is not found in dbs response`,
      ),
    };
  }
  try {
    ProductSchema.parse(dbsProduct);
    return {
      ...product,
      error: undefined,
    };
  } catch (error) {
    const extraInfo = error instanceof ZodError && `\n${JSON.stringify(error.format(), null, 2)}`;
    return {
      ...product,
      error: createProductCardErrorText(
        `product ${product.product_id} on dbs has bad schema${extraInfo ? extraInfo : ''}`,
      ),
    };
  }
};

export default createProductValidator;
